<template lang="html">
  <div v-if="surveyId">
    <app-popup v-if="whatPop"></app-popup>
    <div class="print-version">
      <div class="print-version-header">
        <div class="print-version-header-inside">
          <div class="inside"><div class="kicker">Falck sikkerhedstjek</div>
           <h1>Anbefalinger</h1>

         </div>
        </div>
      </div>
      <div class="card-middle">
        <div class="card-middle-inside">

          <div v-html="checkRisk(surveyId, avarage[surveyId])[0]">
          </div>
          <div class="avarage-bar">
            <div class="avarage-bar-user" :style="{marginLeft: (cData.score - 1)/2*100+'%'}">
              Din virksomhed
            </div>
            <div class="avarage-bar-inside">

            </div>
            <div class="avarage-bar-all" :style="{marginLeft: (Number(allAvarage)-1)/2*100+'%'}" v-if="survey[surveyId].showallcompanys">
              Andre virksomheder
            </div>
          </div>
          <small v-if="survey[surveyId].showallcompanys">Gennemsnittet er beregnet ud fra alle tidligere gennemførte Sikkerhedstjek</small>
        </div>
      </div>
      <div class="print-version-middle">
        <div class="print-version-middle-inside">

          <div v-for="(a, aCount) in cData.answer" :key="a.id" class="card-result">


            <div>
              <h5>{{ survey[surveyId].cat[aCount].name }}</h5>
              <div class="avarage-cat-wrapper">
                <div class="avarage-cat">

                  <div class="avarage-cat-inside" :class="getAvarageCat(aCount)[1]">

                  </div>
                </div>
                <div class="avarage-cat-text">
                  Samlet risiko for {{ survey[surveyId].cat[aCount].name.toLowerCase() }}: <b>{{ getAvarageCat(aCount)[2]}}</b>
                </div>
              </div>
              <div v-html="getAvarageCat(aCount)[0]">
              </div>
            </div>
            <div class="more">
              <table class="result-table" cellpadding="0" cellspacing="0">
                <thead>
                  <tr>
                    <th>
                      <div class="border">
                        Spørgsmål
                      </div>
                    </th>
                    <th>
                      <div class="border">
                        Svar
                      </div>
                    </th>
                    <th>
                      <div class="border">
                        Risiko
                      </div>
                    </th>
                    <th class="result-table-highlighted">
                      <div class="border">
                        Anbefaling
                      </div>
                    </th>
                    <th>
                      <div class="border">
                        Links
                      </div>
                    </th>
                  </tr>
                </thead>

                <tbody v-for="(an, anCount) in cData.answer[aCount].q" :key="an.id">
                  <tr v-for="(svar, svarCount) in cData.answer[aCount].q[anCount].a" :key="svar.id">
                    <td>
                      <div class="border" v-if="svarCount == 0">
                        {{ survey[surveyId].cat[aCount].questions[an.q].title }}
                      </div>
                    </td>
                    <td>
                      <div class="border">
                        {{ survey[surveyId].cat[aCount].questions[an.q].answers[svar].title }}
                      </div>
                    </td>
                    <td>
                      <div class="border">
                        <div>
                          <div class="avarage-cat-inside" :class="checkRisk(surveyId, survey[surveyId].cat[aCount].questions[an.q].answers[svar].score)[1]">

                          </div>
                          <div class="avarage-cat-text">
                            {{ checkRisk(surveyId, survey[surveyId].cat[aCount].questions[an.q].answers[svar].score)[2]}} risiko
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="result-table-highlighted">
                      <div class="border">
                        {{ survey[surveyId].cat[aCount].questions[an.q].answers[svar].recommendation}}
                      </div>
                    </td>
                    <td>
                      <div class="border">
                        <div class="links" v-html="survey[surveyId].cat[aCount].questions[an.q].answers[svar].links">
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>


            </div>
          </div>
        </div>
      </div>
      <app-callussm></app-callussm>
    </div>
    <div class="normal-version">
      <app-qaheader></app-qaheader>
      <div class="card">
        <!-- Module average-->
        <div class="card-middle">
          <div class="card-middle-inside">
            <div v-html="checkRisk(surveyId, avarage[surveyId])[0]">
            </div>
            <div class="avarage-bar">
              <div class="avarage-bar-user" :style="{marginLeft: (cData.score - 1)/2*100+'%'}">
                Din virksomhed
              </div>
              <div class="avarage-bar-inside">

              </div>
              <div class="avarage-bar-all" :style="{marginLeft: (Number(allAvarage)-1)/2*100+'%'}" v-if="survey[surveyId].showallcompanys">
                Andre virksomheder
              </div>
            </div>
            <small v-if="survey[surveyId].showallcompanys">Gennemsnittet er beregnet ud fra alle tidligere gennemførte Sikkerhedstjek</small>
          </div>
        </div>
        <!-- Module average-->


        <div class="card-result-wrapper">
          <div class="card-result">
            <div class="card-result-inside">
              <h3>Alle anbefalinger</h3>
            </div>
          </div>

          <div v-for="(a, aCount) in cData.answer" :key="a.id" class="card-result">


            <div class="card-result-inside">
              <h5>{{ survey[surveyId].cat[aCount].name }}</h5>
              <div class="avarage-cat-wrapper">
                <div class="avarage-cat">
                  <div class="avarage-cat-inside" :class="getAvarageCat(aCount)[1]">

                  </div>
                </div>
                <div class="avarage-cat-text">
                  Samlet risiko for {{ survey[surveyId].cat[aCount].name.toLowerCase() }}: <b>{{ getAvarageCat(aCount)[2]}}</b>
                </div>
              </div>
              <div v-html="getAvarageCat(aCount)[0]">
              </div>
            </div>
            <div class="more" v-show="toggle[aCount].el">
              <div class="rsp-table">
                <div class="rsp-table-head">
                  <div class="rsp-table-row">
                    <div class="rsp-table-column" data-label="Spørgsmål">
                      <div class="border">
                        Spørgsmål
                      </div>
                    </div>
                    <div class="rsp-table-column" data-label="Svar">
                      <div class="border">
                        Svar
                      </div>
                    </div>
                    <div class="rsp-table-column" data-label="Risiko">
                      <div class="border">
                        Risiko
                      </div>
                    </div>
                    <div class="rsp-table-column rsp-table-column-hightlighted" data-label="Anbefaling">
                      <div class="border">
                        Anbefaling
                      </div>
                    </div>
                    <div class="rsp-table-column" data-label="Links">
                      <div class="border">
                        Links
                      </div>
                    </div>
                  </div>
                </div>
                <div class="rsp-table-body" v-for="(an, anCount) in cData.answer[aCount].q" :key="an.id">
                  <div class="rsp-table-row" v-for="(svar, svarCount) in cData.answer[aCount].q[anCount].a" :key="svar.id">
                    <div class="rsp-table-column" data-label="Spørgsmål">
                      <div class="border desktop" v-if="svarCount == 0">
                        {{ survey[surveyId].cat[aCount].questions[an.q].title }}
                      </div>
                      <div class="border mobile">
                        {{ survey[surveyId].cat[aCount].questions[an.q].title }}
                      </div>
                    </div>
                    <div class="rsp-table-column" data-label="Svar">
                      <div class="border">
                        {{ survey[surveyId].cat[aCount].questions[an.q].answers[svar].title }}
                      </div>
                    </div>
                    <div class="rsp-table-column" data-label="Risiko">
                      <div class="border">
                        <div>
                          <div class="avarage-cat-inside" :class="checkRisk(surveyId, survey[surveyId].cat[aCount].questions[an.q].answers[svar].score)[1]">

                          </div>
                          <div class="avarage-cat-text">
                            {{ checkRisk(surveyId, survey[surveyId].cat[aCount].questions[an.q].answers[svar].score)[2]}} risiko
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rsp-table-column rsp-table-column-hightlighted" data-label="Anbefaling">
                      <div class="border">
                        {{ survey[surveyId].cat[aCount].questions[an.q].answers[svar].recommendation}}
                      </div>
                    </div>
                    <div class="rsp-table-column" data-label="Links">
                      <div class="border">
                        <div class="links" v-html="survey[surveyId].cat[aCount].questions[an.q].answers[svar].links">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-result-inside">
              <p>
                <a href="#" @click.prevent.default="toggle[aCount].el = !toggle[aCount].el" class="readmore-plus" v-if="!toggle[aCount].el">
                    Se {{ getAvarageCat(aCount)[3] }} <span v-if="getAvarageCat(aCount)[3] < 2">anbefaling</span><span v-if="getAvarageCat(aCount)[3] > 1">anbefalinger</span> for {{ survey[$route.params.survey].cat[aCount].name.toLowerCase() }}
                </a>
                <a href="#" @click.prevent.default="toggle[aCount].el = !toggle[aCount].el" class="readmore-minus" v-if="toggle[aCount].el">
                    Luk
                </a>
              </p>
            </div>
          </div>
        </div>
        <div class="card-bottom">
          <div class="card-bottom-inside">
            <div class="card-flex">
              <div class="card-flex-one">
                <h4>Falck Sikkerhedstjek</h4>
              </div>
              <div class="card-flex-two">
                <a class="share-link" :href="'mailto:?subject=Falck%20sikkerhedstjek&body=Se%20det%20her:%20'+setUrl">Del</a>
              </div>
              <div class="card-flex-three">
                <a class="print-link" href="#" @click.prevent.default="print">Udskriv</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-callus :hasNext="true" :doPop="true"></app-callus>
    <app-callussm></app-callussm>
    <app-teaser></app-teaser>
    <app-cfooter></app-cfooter>
  </div>
</template>

<script>
import qaheader from './modular/question-header.vue';
import Cfooter from './modular/cfooter.vue';
import Teaser from './modular/teaser.vue';
import Callussm from './modular/call-us-sm.vue';
import Callus from '@/components/modular/call-us.vue';
import Popup from '@/components/modular/popup-permission.vue';
import Marked from 'marked';
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';
import {db} from '../database/firebase';
import Calc from '../modules/calc'

export default {
  name: 'rapport',
  components: {
    appQaheader: qaheader,
    appCfooter: Cfooter,
    appTeaser: Teaser,
    appCallus: Callus,
    appCallussm: Callussm,
    appPopup: Popup
  },
  data () {
    return {
      allAvarage:'',
      surveyId:'',
      answers:'',
      toggle:[]
    }
  },
  firebase() {
    return {
      cData: {
          source: db.ref('answers/' + this.$route.params.survey +'/' + this.$route.params.rapportid),
          asObject: true,
          readyCallback: function () {
            for( var el in this.cData.answer ) {
              this.toggle.push({el:false});
            }
            this.surveyId = this.$route.params.survey
            this.answers = this.cData.answer;
          }
      },
      score: {
        source: db.ref('score/'+this.$route.params.survey),
        readyCallback: function () {
          var sum = 0;
          var oLength = this.score.length;
          for( var el in this.score ) {
            if( this.score.hasOwnProperty( el ) ) {
              sum += parseFloat( this.score[el].score );
            }
          }
          let newValue = sum/oLength
          this.allAvarage = newValue.toFixed(2);
        }
      }
    }
  },
  mounted(){

  },
  computed: {
    ...mapGetters([
      'survey',
      'spinner',
      'surveyIsActive',
      'avarage',
      'whatPop'
    ]),
    setUrl(){
      return 'https://sikkerhedstjek.dk/%23/rapport/'+this.$route.params.survey+'/'+this.$route.params.rapportid
    }
  },
  methods: {
    compiledMarkdown(text) {
      return Marked(text, { sanitize: true })
    },
    print(){
      window.print();
    },
    checkRisk(s, average){
      if(average > 2.5){
        return [this.compiledMarkdown(this.survey[s].recommendationlow),'low','Lav' ]
      }else if(average > 1.5){
        return [this.compiledMarkdown(this.survey[s].recommendationmedium),'medium', 'Mellem']
      }else{
        return [this.compiledMarkdown(this.survey[s].recommendationhigh),'high','Høj']
      }
    },
    getAvarageCat(cat){
      let s = this.$route.params.survey
      let sum = 0;
      let times = 0;
      for (var cAverage in this.answers[cat].q) {
        for (var cScore in this.answers[cat].q[cAverage].score) {
          sum += parseFloat(this.answers[cat].q[cAverage].score[cScore]);
          times++
        }
      }

      let average = sum/times;


      if(average > 2.5){
        return [this.compiledMarkdown(this.survey[s].cat[cat].recommendationlow), "low", "Lav", times]
      }else if(average > 1.5){
        return [this.compiledMarkdown(this.survey[s].cat[cat].recommendationmedium), "medium", "Mellem", times]
      }else{
        return [this.compiledMarkdown(this.survey[s].cat[cat].recommendationhigh), "high", "Høj", times]
      }
    }
  }
}
</script>

<style lang="scss" scoped>

h4{
  margin-bottom: 0;
}
.print-version{
  display: none;
}
.card-bottom{
  min-height: 0;
}
.card-bottom-inside{
  max-width:588px;
  padding: 30px 20px;
  margin:0 auto;
}
.links a {
  display: block;
}
.card-flex-one{
  margin-right: auto;
  font-size: 24px;
  max-width: 400px;
  width:100%;
  @media(max-width: 1023px){
    margin: 8px auto 8px 0;
  }
}
.card-flex-two{
  margin-right: 40px;
  @media(max-width: 1023px){
    margin-top: 8px;
  }
}
.card-flex-three{
  @media(max-width: 1023px){
    margin-top: 8px;
  }
}
.card-flex a{
  color:#fff;
}
.card-flex{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  @media(max-width: 1023px){

  }
}




</style>



// WEBPACK FOOTER //
// src/components/rapport.vue